const trainings = [
  {
    path: 'trainings',
    name: 'trainings',
    icon: 'cil-list-high-priority',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'trainings'
    },
    children: [
      {
        path: '',
        name: 'trainings_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/training/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'trainings'
        }
      },
      {
        path: 'new',
        name: 'training_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/training/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'trainings'
        }
      },
      {
        path: ':id',
        name: 'training',
        components: {
          content: () => import('@/views/pages/training/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'trainings'
        }
      }
    ]
  },
  {
    path: 'btrainings',
    name: 'btrainings',
    icon: 'cil-list-high-priority',
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'b-trainings'
    },
    children: [
      {
        path: '',
        name: 'btrainings_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/btraining/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'b-trainings'
        }
      },
      {
        path: 'new',
        name: 'btraining_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/btraining/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'b-trainings'
        }
      },
      {
        path: ':id',
        name: 'btraining',
        components: {
          content: () => import('@/views/pages/btraining/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'b-trainings'
        }
      }
    ]
  }
]

export default trainings
